import React, { useEffect, useState } from "react";
import { Client, Databases, Query } from "appwrite";
import { useUser } from "./UserContext";
import "./css/Notifications.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";

function Notifications() {
  const { user } = useUser();
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!user?.email) return;

    const client = new Client()
      .setEndpoint("https://cloud.appwrite.io/v1")
      .setProject(process.env.REACT_APP_PROJECT_ID);

    const databases = new Databases(client);

    const fetchNotifications = async () => {
      try {
        const response = await databases.listDocuments(
          process.env.REACT_APP_DATABASE_ID,
          process.env.REACT_APP_COLLECTION_NOTIFICATIONS,
          [Query.equal("recipient", user.email), Query.orderDesc("$createdAt")]
        );
        setNotifications(response.documents);
      } catch (error) {
        console.error("❌ Failed to fetch notifications:", error);
      }
    };

    fetchNotifications();
  }, [user?.email]);

  return (
    <div className="notification-dropdown">
      {notifications.length === 0 ? (
        <div className="notification-item notification-empty">
          No new notifications.
        </div>
      ) : (
        notifications.map((note) => (
          <div
            key={note.$id}
            className="notification-item"
            onClick={() => navigate("/your-products/sold")}
          >
            <strong className="notification-title">{note.title}</strong>
            <p className="notification-body">
              {note.body.replace(/•/g, "\n•")}
            </p>
            <p className="notification-timestamp">
              {new Date(note.$createdAt).toLocaleString()}
            </p>
          </div>
        ))
      )}
    </div>
  );
}

export default Notifications;
